import styled from "styled-components";

const RightButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export default RightButtonContainer;
